import $ from 'jquery';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var $modal = $( '[data-modal]' );

if ($modal.length) {
  
  $( window ).on( 'hashchange', function( e ) {
    updateModal( location.hash );
  });

  updateModal( location.hash );

  function updateModal( hash ) {

    if ( hash && hash.startsWith("#!") ) {
      if ( hash !== "#!" ) {
        disableBodyScroll( document.getElementById( hash.substr(1) ) );
      } else {
        clearAllBodyScrollLocks();
      }
    }
    
  }
}

var $galleryModal = $( '[gallery-data-modal]' );

if ( $galleryModal.length ) {
  
  $( window ).on( 'hashchange', function( e ) {
    updateModal( location.hash );
  });

  updateModal( location.hash );

  function updateModal( hash ) {

    if ( hash && hash.startsWith( "#!" ) ) {
      if ( hash !== "#!" ) {
        disableBodyScroll( document.getElementById( hash.substr(1) ) );
      } else {
        clearAllBodyScrollLocks();
      }
    }
    
  }
}

// simple validate check, if not validated, it will highlight red
if( $( '.form-wrapper' ).length ){
  $( '.validate' ).blur( function(){
      if( ! $( this ).val() ){
          $( this ).addClass( 'error' );
      } else{
          $( this ).removeClass( 'error' );
      }
  })
};
